const platform = require('platform');

const errorClass = 'error';

$.validator.addMethod(
    'email',
    function(value, element, param) {
        if (value.length) {
            var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
            return regex.test(value);
        } else {
            return true;
        }
    },
    $.validator.format('Enter correct E-mail')
);

// UK phone validation method
$.validator.addMethod(
    'validationPhone',
    function(value, element) {
        var regex = /^[\d\s\+\-\,\.\(\)]*$/;
        return regex.test(value);
    },
    $.validator.format('Enter correct phone number')
);

$.validator.addMethod(
    'filesize',
    function(value, element) {
        return element.files[0].size <= 10485760 && element.files[0].size > 0;
    },
    $.validator.format('Invalid file size (max size - 10 Mb)')
);

$.validator.addMethod(
    'extension',
    function(value, element, param) {
        param =
            typeof param === 'string'
                ? param.replace(/,/g, '|')
                : 'docx?|rtf|pdf';
        return (
            this.optional(element) ||
            value.match(new RegExp('\\.(' + param + ')$', 'i'))
        );
    },
    $.validator.format('Invalid file format (doc, docx, pdf, rtf)')
);

//Очистка формы
global.resetForm = function($form = $('.js-form')) {
    $form.each(function(key, form) {
        let $form = $(form);
        var validator = $form.validate();
        validator.resetForm();
        $form.trigger('reset');

        $form
            .find(
                'input[type=text], input[type=email], input[type=password], input[type=file], select, textarea'
            )
            .val('')
            .removeClass(`form__label--success ${errorClass}`)
            .closest('label')
            .removeClass('form__label--focused'); // check

        // CUSTOM CLM
        if ($form.find('.js-select--form--default-1').length) {
            $form.find('.js-select--form--default-1').val(function() {
                return $(this)
                    .find('option')
                    .eq(0)
                    .val();
            });
        }

        $form.find('.form__input--vacancy--detail').val(function() {
            return $(this).data('value');
        });

        $form.find('.js-select--form--vacancy-detail').val(function() {
            return $(this).data('value');
        });

        $form.find('.js-file-input__label').text('doc, docx, pdf, rtf');

        $form.find('.file-input__wrapper').removeClass('filled');

        $form.find('.js-file-input__btn').removeClass('file-input__btn--reset');
        // END CUSTOM CLM

        $form.find('select').trigger('change');

        $form
            .find('input[type=radio], input[type=checkbox]')
            .prop('checked', false)
            .removeAttr('checked')
            .removeAttr('selected')
            .closest('label')
            .removeClass(
                `form__label--success ${errorClass} checkbox__label--checked radio__label--checked`
            )
            .closest('.checkbox, .radio')
            .removeClass(`form__label--success ${errorClass}`);

        clearFileInput($form.find('.form__file-upload-btn--reset'));
    });
};

//Валидация формы
global.initValidationForms = function(form = '.js-form') {
    $(form).each(function(key, form) {
        $(form).validate({
            errorElement: 'div',
            errorClass,
            validClass: '',
            submitHandler: function(form, event) {
                if ($(form).attr('id') == 'news-subscribe') {
                    let actionPath = $(form).attr('action'),
                        email = $(form)
                            .find('#email')
                            .val();
                    location.href = `${actionPath}/?${encodeURI(
                        `sf_RUB_ID[0]=1&sf_EMAIL=${email}&OK=Subscribe`
                    )}`;
                    return false;
                }
                if (!$(form).hasClass('js-form--non-ajax')) {
                    event.preventDefault();

                    let $captcha = $(form).find('input[name="captcha_sid"]'),
                        $gcaptcha = $(form).find('.form__gcaptcha'),
                        $submitBtn = $(form).find('input[type=submit]'),
                        $preloader = $(
                            `<div class="form__preloader"><div class="preloader"></div></div>`
                        );

                    function startSend() {
                        $submitBtn
                            .addClass('btn--disabled')
                            .prop('disabled', true);

                        $preloader
                        .appendTo($(form))
                        .velocity('fadeIn');
                    }

                    function endSend() {
                        if (
                            $submitBtn.hasClass('btn--disabled') ||
                            $(form).find('.form__preloader').length
                        ) {
                            $submitBtn
                                .removeClass('btn--disabled')
                                .prop('disabled', false);
                            $(form)
                                .find('.form__preloader')
                                .velocity('fadeOut')
                                .remove();
                        }
                    }

                    startSend();

                    if ($captcha.length) {
                        let csid = $(form).find('#captcha_sid'),
                            cword = $(form).find('#captcha_word');

                        $.get(
                            `/ajax/captcha.php?captcha_sid=${csid.val()}&captcha_word=${cword.val()}`, function(response) {
                                if (response.toString() == '0') {
                                    showNotyfications(
                                        'Enter a valid captcha code',
                                        { type: 'error sm' }
                                    );
                                    endSend();
                                } else {
                                    postFormData($(form), () => {
                                        endSend();
                                    });

                                }

                                /* refresh captcha */
                                reloadCaptcha($(form));
                            });
                    } else if ($gcaptcha.length) {
                        let action = $gcaptcha.attr('name');

                        grecaptcha.ready(function() {
                            grecaptcha.execute('6LdGn6wUAAAAAH9C51w5CunDbXFUDsUp1VldxIxT', {
                                action: action
                            }).then(function(token) {
                                document.querySelector(`[name="${action}"]`).value = token;
                                postFormData($(form), () => {
                                    endSend();
                                });
                            }, function(reason) {
                                showNotyfications(reason, { type: 'error' });
                            });
                        });
                    } else {
                        postFormData($(form), () => {
                            endSend();
                        });
                    }
                } else {
                    if ($(form).valid()) {
                        form.submit();
                    }
                }
                return false;
            },
            invalidHandler: function(form) {
                // const $el = $(form.target).find('.js-form-el');
                // const $checkbox = $(form.target).find('.js-checkbox');

                // checkValidtaionEl($el);
                // checkValidtaionEl($checkbox);
            },
            errorPlacement: function(error, element) {
                if (element.is('select')) {
                    error.insertAfter(element.siblings('.select2'));
                } else if (element.is(':radio')) {
                    element.closest('.js-radio').addClass(errorClass);
                    error.insertAfter(element);
                } else if (element.is(':checkbox')) {
                    element.closest('.js-checkbox').addClass(errorClass);
                    error.insertAfter(element);
                } else {
                    error.insertAfter(element);
                    if ($(element).hasClass('js-mask-phone')) {
                        element.closest('.intl-tel-input').addClass(errorClass);
                    }
                }
            },
            success: function(element) {
                // $(element)
                //     .parent('.form__control-wrapper')
                //     .addClass('success');
            }
        });
    });
};

global.postFormData = function($form, callback) {
    let formData = new FormData($form[0]);

    $.ajax({
        url: '/ajax/forms.php',
        type: 'POST',
        data: formData,
        async: false,
        cache: false,
        contentType: false,
        processData: false,
        success: function(res) {
            let response = JSON.parse(res);
            if (response.success) {
                showNotyfications(response.msg, { type: 'success' });
                resetForm($form);
                callback();
            } else {
                showNotyfications(response.msg, { type: 'error' });
                callback();
            };
        }
    });
};

function checkValidtaionEl($el) {
    $el.each(function(key, el) {
        let isValid = $el.valid();

        if (isValid) {
            if ($el.hasClass('js-radio')) {
                $el.closest('.radio').removeClass(errorClass);
            }

            if ($el.hasClass('js-mask-phone')) {
                $el.closest('.intl-tel-input').removeClass(errorClass);
            };
        } else {
            if ($el.hasClass('js-radio')) {
                $el.closest('.radio').addClass(errorClass);
            }

            if ($el.hasClass('js-mask-phone')) {
                $el.closest('.intl-tel-input').addClass(errorClass);
            }
        }
    });
}

function reloadCaptcha($form) {
    $.get('/ajax/captcha_reload.php', function(data) {
        $form
            .find('#captcha_sid')
            .val(data);
        $form
            .find('.captcha__img')
            .attr('src', '/bitrix/tools/captcha.php?captcha_sid=' + data);
        $form
            .find('#captcha_word')
            .val('');
    });
}

$(document).on('click', '.js-captcha-reload', function(e) {
    e.preventDefault();
    reloadCaptcha($(this).closest('form'));
});

$(document).on('submit', '.js-form', function(event) {
    checkValidtaionEl($(this).find('.js-form-el'));
});

$(document).on(
    'keyup click select2:select select2:unselect',
    '.js-form-el',
    function(e) {
        checkValidtaionEl($(this));
    }
);

initValidationForms();

// custom file input
$('.js-file-input').on('change', function () {
    var $this = $(this),
        str = $this.val(),
        fileCount = $this[0].files.length;

    if (fileCount > 0) {
        $this.siblings('.js-file-input__btn').addClass('form__file-upload-btn--reset');
        $this.focusout();

        $this.closest('.form__file-upload-wrapper').addClass('filled');
    } else {
        $this.siblings('.js-file-input__btn').removeClass('form__file-upload-btn--reset');
        $this.focusout();

        $this.closest('.form__file-upload-wrapper').removeClass('filled');
    }

    if (fileCount > 1) {
        var i = 'Files: ' + fileCount;
    } else if (fileCount == 1) {
        if (str.substring(str.lastIndexOf('\\'))) {
            var i = str.substring(str.lastIndexOf('\\') + 1);
        } else {
            var i = str.substring(str.lastIndexOf('/') + 1);
        }
    } else {
        var i = $(this).siblings('.js-form__placeholder').data('text');
    }

    var uploaded = $this.siblings('.js-form__placeholder');
    uploaded[0].innerText = i;
});

function clearFileInput($el) {
    if ($el.hasClass('form__file-upload-btn--reset')) {
        $el
            .siblings('.js-file-input')
            .val('')
            .siblings('.js-form__placeholder')
            .text($el.siblings('.js-form__placeholder').data('text'));
        $el.removeClass('form__file-upload-btn--reset');
        $el.closest('.form__file-upload-wrapper').removeClass('filled');
    }
}

$('.js-file-input__btn').on('click', e => {
    e.preventDefault();
    clearFileInput($(e.currentTarget))
});



// WEBPACK FOOTER //
// ./frontend/components/validation-forms/validation-forms.js